import { configService } from "@/_services";

// import router, { resetRouter } from "@/router";

const state = {
  config: {}
};

const mutations = {
  SET_CONFIG: (state, config) => {
    state.config = config;
  }
};

const actions = {
  getConfig({ commit }) {
    return new Promise((resolve, reject) => {
      configService
        .findAll()
        .then(response => {
          const { data } = response;
          let configs = [];
          configs["COMPANY_ADDRESS"] = "";
          configs["COMPANY_EMAIL"] = "";
          configs["COMPANY_NAME"] = "";
          configs["COMPANY_PHONE"] = "";
          configs["COMPANY_TAXCODE"] = "";

          data.forEach(element => {
            // if (configs[element.key]) {
            //   configs[element.key].id = element.id;
            //   configs[element.key].key = element.key;
            //   configs[element.key].value = element.value;
            //   configs[element.key].description = element.description;
            // } else {
            //   configs[element.key] = element;
            // }
            if (element.key.includes("COMPANY"))
              configs[element.key] = element.value;
          });
          commit("SET_CONFIG", configs);
          resolve(configs);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
